import {Dispatch} from "react";
import {IAction} from "src/context/IAction";
import {IEvent} from "src/context/models/Event";
import {CONNECTION_ERROR} from "src/common/constants/constants";
import {deleteEvent, fetchEventsAPI, fetchEventsS3, postEvent} from "src/service/ServiceMethods";
import {
    DELETE_EVENT,
    DELETE_EVENT_FAILURE,
    DELETE_EVENT_SUCCESS,
    FETCH_EVENTS,
    FETCH_EVENTS_FAILURE,
    FETCH_EVENTS_SUCCESS,
    POST_EVENT,
    POST_EVENT_FAILURE,
    POST_EVENT_SUCCESS
} from "src/context/actions/ActionTypes";

export function fetchEventsAction(dispatch: Dispatch<IAction>, queryAPI: boolean) {
    (queryAPI ? fetchEventsAPI() : fetchEventsS3())
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw response.statusText;
        })
        .then((resolvedResponse) => {
            dispatch({
                type: FETCH_EVENTS_SUCCESS,
                payload: resolvedResponse,
            });
        })
        .catch((err) => {
            dispatch({
                type: FETCH_EVENTS_FAILURE,
                payload: !err ? CONNECTION_ERROR : err,
            });
        });
    dispatch({
        type: FETCH_EVENTS
    });
}

export function postEventAction(dispatch: Dispatch<IAction>, event: IEvent) {
    postEvent(event)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw response.statusText;
        })
        .then((resolvedResponse) => {
            dispatch({
                type: POST_EVENT_SUCCESS,
                payload: resolvedResponse,
            });
            location.reload();
        })
        .catch((err) => {
            dispatch({
                type: POST_EVENT_FAILURE,
                payload: !err ? CONNECTION_ERROR : err,
            });
        });
    dispatch({
        type: POST_EVENT
    });
}

export function deleteEventAction(dispatch: Dispatch<IAction>, event: IEvent) {
    deleteEvent(event)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw response.statusText;
        })
        .then((resolvedResponse) => {
            dispatch({
                type: DELETE_EVENT_SUCCESS,
                payload: resolvedResponse,
            });
            location.reload();
        })
        .catch((err) => {
            dispatch({
                type: DELETE_EVENT_FAILURE,
                payload: !err ? CONNECTION_ERROR : err,
            });
        });
    dispatch({
        type: DELETE_EVENT
    });
}